import { render, staticRenderFns } from "./DDDraftList.vue?vue&type=template&id=6310d086&"
import script from "./DDDraftList.vue?vue&type=script&lang=js&"
export * from "./DDDraftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6310d086')) {
      api.createRecord('6310d086', component.options)
    } else {
      api.reload('6310d086', component.options)
    }
    module.hot.accept("./DDDraftList.vue?vue&type=template&id=6310d086&", function () {
      api.rerender('6310d086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/directDebit/DDDraftList.vue"
export default component.exports